export default "__VITE_ASSET__3nqWOaMm__"